import { motion } from 'motion/react';
import styles from './QrCodes.module.css';
import { useGetParams } from '../../hooks/useGetParams';

export const QrCodes = () => {
  const { qrCode1, qrCode2, qrTitle1, qrTitle2, sizeQR } = useGetParams();

  const clrBorder = {
    whatsapp: '#a0ffa4',
    telegram: '#28A5E5',
  };

  return (
    <>
      {qrCode1 && (
        <div
          className={styles.qrCode}
          style={{
            width: `${sizeQR}rem`,
            height: `${sizeQR}rem`,
          }}
        >
          <motion.img
            initial={{ scale: 0 }}
            animate={{
              scale: 1,
              transition: { duration: 0.64, delay: 0.12 + 0.32 + 0.2 },
            }}
            exit={{
              scale: 0,
              transition: { duration: 0.64, delay: 0.32 },
            }}
            src={qrCode1}
            alt=""
          />
          <motion.div
            initial={{ scale: 0 }}
            animate={{
              scale: 1,
              transition: { duration: 0.64, delay: 0.32 + 0.2 },
            }}
            exit={{
              scale: 0,
              transition: { duration: 0.64, delay: 0.12 + 0.32 },
            }}
            className={styles.borderQr}
            style={{
              borderColor: clrBorder[qrTitle1],
            }}
          />
        </div>
      )}
      {qrCode2 && (
        <div
          className={styles.qrCode}
          style={{
            width: `${sizeQR}rem`,
            height: `${sizeQR}rem`,
          }}
        >
          <motion.img
            initial={{ scale: 0 }}
            animate={{
              scale: 1,
              transition: { duration: 0.64, delay: 0.12 + 0.32 },
            }}
            exit={{
              scale: 0,
              transition: { duration: 0.64, delay: 0.32 + 0.2 },
            }}
            src={qrCode2}
            alt=""
          />
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1, transition: { duration: 0.64, delay: 0.32 } }}
            exit={{
              scale: 0,
              transition: { duration: 0.64, delay: 0.12 + 0.32 + 0.2 },
            }}
            className={styles.borderQr}
            style={{
              borderColor: clrBorder[qrTitle2],
            }}
          />
        </div>
      )}
    </>
  );
};
